// A manifest widget's `visibleFn` gate (G-H, 2026-10-28) — the ONE evaluation
// both boards share: the home board (pages/main.js _allModuleWidgetsFor, fails
// OPEN) and the assistant board (functions/assistantBoard.js
// boardVocabularyFor, through `this.call`, fails CLOSED).
//
// The gate is a MODULE function, resolved in its owning app's own scope
// (root._moduleFnGet(name, ownerId) — two apps may name the same gate), and
// called as fn(widgetId, root) with `this` = a shim carrying `call` and
// `state.root`, because module functions expect an element.
//
// THE SHIM'S `call` (G-H, found by BESSI lane F): it resolved ONLY the app's
// own functions, so `this.call('moduleRole')` / `this.call('moduleCan', key)`
// answered undefined inside a gate — the shell bridges live in the shell bag
// (workspaceProjects.js capFns), not in the app's own scope. It now resolves
// like a real element's el.call: the app's own function first, then the shell
// function bag (root._moduleFnGet with no owner).
//
// RE-RUN ON `access` (G-H): the board factories re-run on what their LAST run
// read (smbls dynamic tracking). A first run that met no gate function yet
// (the app's functions inject later, with no root signal) read nothing about
// the member, so the arrival of the workspace record's `access` never re-ran
// it: the fail-open answer stayed for the session. The evaluation reads
// root.workspace.access first, every time — the field moduleRole / moduleCan
// answer from (moduleAccessBridge.js) — so every board that gates a widget
// re-runs when the member's access lands or changes.
//
// ONE self-contained export (frank ships every export on its own): the shim
// is built inside, not by a sibling helper.

// true / false from the gate; `fallback` when the widget's gate function has
// not injected yet or throws.
export const moduleWidgetGateAllows = function moduleWidgetGateAllows(
  root,
  widget,
  ownerId,
  fallback
) {
  if (!widget || !widget.visibleFn) return true
  // Subscribe the calling factory to the member's access before anything
  // can return (see RE-RUN ON `access` above).
  const workspace = root && root.workspace
  void (workspace && workspace.access)
  const get = root && root._moduleFnGet
  if (typeof get !== 'function') return fallback
  const gate = get(widget.visibleFn, ownerId)
  if (typeof gate !== 'function') return fallback
  const shim = {
    state: { root },
    call: (name, ...args) => {
      const fn = get(name, ownerId) || get(name)
      return typeof fn === 'function' ? fn.apply(shim, args) : undefined
    }
  }
  try {
    return !!gate.call(shim, widget.id, root)
  } catch (_) {
    return fallback
  }
}
